import { render, staticRenderFns } from "./group-title.vue?vue&type=template&id=a1782838&scoped=true&"
import script from "./group-title.vue?vue&type=script&lang=js&"
export * from "./group-title.vue?vue&type=script&lang=js&"
import style0 from "./group-title.vue?vue&type=style&index=0&id=a1782838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1782838",
  null
  
)

export default component.exports